import Icon from '../components/Icon.vue'

Icon.register({
  'plane-arrival': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448zM44.8 205.7L133.6 285.7A62.6-62.6 0 0 1 159 299.6L446.6 377.9C473.1 385.1 501.2 386.7 527.6 379.3 557.3 371 571.1 358.1 574.9 343.6 578.7 329.1 573.1 310.9 551.5 288.6 532.2 268.8 507.1 255.8 480.7 248.6L383.2 222.1 282.8 30.2C281.3 24.4 276.9 19.9 271.1 18.3L206.1 0.6C195.5-2.3 185.2 5.9 185.3 17L233.3 181.2 131.1 153.4 103.5 85.5C101.5 80.6 97.5 76.9 92.5 75.6L52.7 64.8C42.4 61.9 32.2 69.8 32 80.6L32.2 182.4C32.4 191.3 38.3 199.8 44.8 205.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/plane-arrival.js
// module id = gtWR
// module chunks = 144